import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

export type SPBenefitTokenSearchLocs =
	| 'SPBenefitTokenSearchTitleSection'
	| 'SPBenefitTokenSearchLabelTokenId'
	| 'SPBenefitTokenSearchButtonClear'
	| 'SPBenefitTokenSearchButtonSubmit'
	| 'SPBenefitTokenSearchContentNoResults';

export const spBenefitTokenSearchLocs: LocDefs<SPBenefitTokenSearchLocs> = {
	SPBenefitTokenSearchTitleSection: {
		defaultValue: 'Token Search',
		description: 'Title for the token search section',
		displayPath: 'Catalogs|BenefitTokens|Search|Title|SearchSection',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Search.Title.SearchSection',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenSearchLabelTokenId: {
		defaultValue: 'Token ID',
		description: 'Label for the token ID input field',
		displayPath: 'Catalogs|BenefitTokens|Search|Field Label|TokenID',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Search.FieldLabel.TokenID',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenSearchButtonClear: {
		defaultValue: 'Clear',
		description: 'Button text to clear the token ID search field',
		displayPath: 'Catalogs|BenefitTokens|Search|Button|ClearSearch',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Search.Button.ClearSearch',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenSearchButtonSubmit: {
		defaultValue: 'Search for Token',
		description: 'Button text to submit the token search',
		displayPath: 'Catalogs|BenefitTokens|Search|Button|SearchSubmit',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Search.Button.SearchSubmit',
		portal: 'SP' as LocPortal,
	},
	SPBenefitTokenSearchContentNoResults: {
		defaultValue: 'No results found',
		description: 'Message shown when no tokens are found matching the search criteria',
		displayPath: 'Catalogs|BenefitTokens|Search|Content|SearchNoResults',
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Catalogs.BenefitTokens.Search.Content.SearchNoResults',
		portal: 'SP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<SPBenefitTokenSearchLocs>(spBenefitTokenSearchLocs);
export type SpBenefitTokenSearchLocKeys = LocMap<SPBenefitTokenSearchLocs>;
